import { buildFunnelData } from '../../utils/metricTags';
import './Analytics.scss';

export default function SalesFunnel({ tagSummary, onStepClick }) {
    const steps = buildFunnelData(tagSummary);
    const maxCount = Math.max(...steps.map((step) => step.count), 1);

    return (
        <div className="analytics-funnel">
            {steps.map((step) => (
                <button
                    key={step.tag}
                    type="button"
                    className="analytics-funnel__step"
                    onClick={() => onStepClick?.(step.tag)}
                >
                    <span className="analytics-funnel__label">
                        {step.label}
                        {step.hint && (
                            <span className="analytics-funnel__hint">{step.hint}</span>
                        )}
                    </span>
                    <span className="analytics-funnel__bar-wrap">
                        <span
                            className="analytics-funnel__bar"
                            style={{ width: `${Math.max(2, (step.count / maxCount) * 100)}%` }}
                        />
                    </span>
                    <span className="analytics-funnel__stats">
                        <span className="analytics-funnel__count">{step.count}</span>
                        {step.conversionFromPrev != null && (
                            <span className="analytics-funnel__conversion">
                                {step.conversionFromPrev}
                                % от пред.
                            </span>
                        )}
                    </span>
                </button>
            ))}
        </div>
    );
}
